/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Failedtocancelevent3Inputs */

const en_failedtocancelevent3 = /** @type {(inputs: Failedtocancelevent3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to cancel event`)
};

const de_failedtocancelevent3 = /** @type {(inputs: Failedtocancelevent3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event konnte nicht abgesagt werden`)
};

/**
* | output |
* | --- |
* | "Failed to cancel event" |
*
* @param {Failedtocancelevent3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const failedtocancelevent3 = /** @type {((inputs?: Failedtocancelevent3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failedtocancelevent3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_failedtocancelevent3(inputs)
	return de_failedtocancelevent3(inputs)
});
export { failedtocancelevent3 as "failedToCancelEvent" }